export default (message, searchList) => (
  searchList.some((l) => l.messageId === message.key)
    ? searchList.find((l) => l.messageId === message.key).color
    : '#ccc'
);
